// The shared half of every tool's table, ja (machine-written, unread — ruling G4).
// Same leaves as en.js; composed under each tool's own table by compose() (@3dp/ui/i18n).
export const SHARED_JA = {
  back: "ツール一覧",   // the home link's word; its arrow is the template's (R70: at the phone layout the link shows the arrow alone, this word is its aria-label)
  text: "テキスト",
  font: "フォント",
  dl3mf: "3MFを保存",
  share: "リンクをコピー",
  updating: "計算中…",
  exportFail: "ダウンロードに失敗しました",
  useFont: (family, mb) => `${family} を使用（${mb} MB）`,
  pickFromList: "フォント一覧の別のフォントにあるかもしれません",   // R83: after the offered family, what it lacks — the list holds the others
  fontFailed: (family) => `${family} を読み込めません — 接続を確認 · 現在のフォントを使用`,
  fontNotOffered: (asked) => `リンクのフォント ${asked} はこのページにありません — Kanit を使用`,
  pick: "SVGファイルを選ぶ",
  reading: "ファイルを読み込み中…",
  notSvg: "SVGファイルのみ対応 — Illustratorでは「書き出し形式 → SVG」を選び、先にテキストをアウトライン化してください",
  svgTooBig: "ファイルが大きすぎるか細かすぎます — 点数を減らすか図形を統合し、新しいSVGを書き出してください",
  svgEmpty: "塗りのある図形が見つかりません — 線とテキストを先にアウトライン化してください",
  svgBad: "このファイルは読み込めません — 利用可能なSVGではありません",
  readFail: "ファイルを読み込めません — もう一度選択してください",
  skipped: {
    background: (n) => `背景 ${n} 件 — 削除しました`,
    bad: (n) => `読み込めない図形 ${n} 件 — スキップしました`,
    clipped: (n) => `クリップマスク付きの図形 ${n} 件 — 図形全体を使用（クリップなし）`,
    hidden: (n) => `非表示の部分 ${n} 件 — 使用しません`,
    image: (n) => `ビットマップ ${n} 件 — ベクター図形のみ使用できます`,
    stroke: (n) => `塗りのない線 ${n} 本 — 先にアウトライン化してください`,
    stroked: (n) => `線付きの図形 ${n} 件 — 線幅は含まれません`,
    text: (n) => `テキスト要素 ${n} 件 — 先にアウトライン化してください`,
  },
  badLink: "このリンクは利用できません — 既定のデザインを開きました",
  newerLink: "このリンクは新しいバージョンのものです — 既定のデザインを開きました",
  buildFail: "計算に失敗しました — 値を調整してもう一度お試しください",
  lineHint: "ダウンロードするにはブラウザで開いてください",
  shareNoLogo: "このリンクにロゴファイルは含まれません — 開く人がSVGを選ぶ必要があります",
  linkNeedsLogo: "このデザインはファイルのロゴを使いますが、リンクには含まれません — SVGファイルを選んで追加してください",
  h: "高さ（mm）",
  numHint: (lo, hi) => `${lo}–${hi} の数値を入力してください`,
  percent: (v) => `${Math.round(v * 100)}%`,
  slot: (n) => `スロット ${n}`,
  parts: {
    lid: "フタ",
  },
  fits: {
    loose: "ゆるめ",
  },
  finishes: {
    engraved: "彫刻",
  },
  lookNames: {
    filasophy: "Filasophy",
  },
  viewGroup: "表示",
  sources: {
    none: "なし",
    svg: "SVGファイル",
    text: "テキスト",
  },
  mood: {
    all: "すべて",
    bold: "太字",
    cute: "キュート",
    handwritten: "手書き",
    neat: "整然",
    tech: "テック",
  },
  problem: {
    "missing-chars": (p) => `このフォントにない文字: ${p.chars.slice(0, 12).join(' ')}`,
    "text-too-complex": "テキストが細かすぎます — 文字を減らすか別のフォントを — ダウンロードできません",
  },
  noGl: "このブラウザは3Dを表示できませんが、ダウンロードは可能です",
  needFileLine: "LINE内ではダウンロードできません — 先にブラウザでこのページを開き、ファイルを選んでください",
  undo: "元に戻す",
  redo: "やり直す",
  machineNote: "機械翻訳・未校正",   // shown by ja/zh pages only ("machine-written, unread")
  // ship 3 piece f (ruling R21): the language switch, its cannot-carry note, and the English-page offer
  langSwitchLabel: "言語",
  switchNoFile: "リンクにアップロードされたファイルは含まれません — 切り替え後に再度選ぶ必要があります",
  offerLine: "このページを日本語で見る",
  offerDismiss: null,
  // the font control and the font sheet (@3dp/ui font-control.js, picker.js — unify-ui ship 4a, moved from name-tag)
  pickFont: "フォントを選ぶ",
  close: "閉じる",
  weight: "フォントの太さ",
  weightName: (w) => `${w} ${{ 100: 'ウルトラライト', 200: 'エクストラライト', 300: 'ライト', 400: 'レギュラー', 500: 'ミディアム', 600: 'セミボールド', 700: 'ボールド', 800: 'エクストラボールド', 900: 'ウルトラボールド' }[w] || ''}`.trim(),
  scriptName: {
    latin: "ラテン",
    thai: "タイ語",
    japanese: "日本語",
    "chinese-simplified": "簡体中文",
    "chinese-traditional": "繁体中文",
    han: "中国語/日本語",
    other: "その他の文字",
  },
  chipRemove: "すべての文字体系のフォントを表示",
  chipMark: "×",
  noFontForText: "このテキストをカバーするフォントがありません — 別の文字体系をお試しください",
  noFontInMood: "このグループにフォントがありません",
  fontLoadFailed: "読み込めません — 接続を確認してください",
  sample: {
    japanese: "名札",
    "chinese-simplified": "名牌",
    "chinese-traditional": "名牌",
  },
  moreFonts: "他のフォント（Google Fonts）",
  backToCurated: "← おすすめフォント",
  searchFonts: "フォントを検索",
  category: {
    all: "すべて",
    "sans-serif": "サンセリフ",
    serif: "セリフ",
    display: "ディスプレイ",
    handwriting: "手書き",
    monospace: "等幅",
  },
  untested: "まだプリントテストしていません",
  noFontFound: "フォントが見つかりません — 別の言葉やカテゴリをお試しください",
  catalogLoading: "フォント一覧を読み込み中…",
  catalogFailed: "フォント一覧を読み込めません — 接続を確認してください",
  mb: (mib) => `${mib.toFixed(1)} MB`,
  // the colour control (@3dp/ui colours.js — unify-ui ship 4b, moved from name-tag): the own-colour input, an own colour's caption
  customColor: "カスタム…",
  customCaption: "カスタム",
};
